var map = {
	"./blog-1.jpg": 235,
	"./blog-2.jpg": 236,
	"./blog-five1.jpg": 237,
	"./blog-five2.jpg": 238,
	"./blog-five3.jpg": 239,
	"./blog-standard-1.jpg": 33,
	"./blog-standard-2.jpg": 49,
	"./blog-standard-3.jpg": 50,
	"./call-action-widget.jpg": 240,
	"./comment-author-1.jpg": 51,
	"./comment-author-2.jpg": 52,
	"./comment-author-3.jpg": 53,
	"./footer-widget-1.jpg": 241,
	"./footer-widget-2.jpg": 242,
	"./hd.jpg": 243,
	"./iit.jpg": 244,
	"./iit.png": 245,
	"./navic-chip.jpg": 246,
	"./navic-clock.jpg": 247,
	"./news-1.jpg": 248,
	"./news-10.jpg": 249,
	"./news-11.jpg": 250,
	"./news-12.jpg": 251,
	"./news-13.jpg": 252,
	"./news-14.png": 253,
	"./news-15.png": 254,
	"./news-16.jpeg": 255,
	"./news-17.jpeg": 256,
	"./news-18.jpeg": 257,
	"./news-19.jpg": 258,
	"./news-2.jpg": 259,
	"./news-20.jpeg": 260,
	"./news-3.jpg": 261,
	"./news-4.jpg": 262,
	"./news-5.jpg": 263,
	"./news-6.jpg": 264,
	"./news-7.jpg": 265,
	"./news-8.jpg": 266,
	"./news-9.jpg": 267,
	"./news-author-1.jpg": 268,
	"./news-author-2.jpg": 269,
	"./news-author-3.jpg": 270,
	"./news-bg-two.jpg": 271,
	"./news-bg.jpg": 272,
	"./news-six1.jpg": 273,
	"./news-six2.jpg": 274,
	"./news-six3.jpg": 275,
	"./news-widget-1.jpg": 34,
	"./news-widget-2.jpg": 35,
	"./news-widget-3.jpg": 36,
	"./news1.jpg": 276,
	"./news2.jpg": 277,
	"./news3.jpg": 278,
	"./rit.png": 279,
	"./tele.png": 280
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 234;